// Page dependencies
export const RESOLVE_DEPENDENCIES = 'RESOLVE_DEPENDENCIES';
export const RESOLVE_DEPENDENCIES_LOAD = 'RESOLVE_DEPENDENCIES_LOAD';
export const RESOLVE_DEPENDENCIES_SUCCESS = 'RESOLVE_DEPENDENCIES_SUCCESS';
export const RESOLVE_DEPENDENCIES_ERROR = 'RESOLVE_DEPENDENCIES_ERROR';
